export const DIGISIGN_LINK = 'https://view.julo.co.id/digisign/privy';
